<div class="dialog">
  <app-dialog-header>
    {{ "ACCOUNT_MANAGERS.ADD_TITLE" | translate }}
  </app-dialog-header>

  <ng-container *ngIf="isLoading">
    <app-loader-spinner-general
      [repeat]="2"
      [loadingType]="LoadingType.INPUT"
    ></app-loader-spinner-general>
    <app-loader-spinner-general
      [repeat]="2"
      class="d-flex justify-content-end"
      [loadingType]="LoadingType.BUTTONS"
    ></app-loader-spinner-general>
  </ng-container>

  <ng-container *ngIf="!isLoading">
    <div class="dialog-body">
      <form [formGroup]="form">
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>{{
            "ACCOUNT_MANAGERS.PLACEHOLDER" | translate
          }}</mat-label>
          <mat-select
            formControlName="account_manager_ids"
            multiple
            disableOptionCentering
            panelClass="account-managers-panel"
          >
            <mat-select-trigger>
              <mat-chip-listbox class="chips-select-list">
                <mat-chip
                  *ngFor="let adminId of form.get('account_manager_ids')?.value"
                  [removable]="true"
                  (removed)="removeSelectedAdmin(adminId)"
                >
                  {{ getSelectedAdminLabel(adminId) }}
                  <mat-icon matChipRemove (click)="$event.stopPropagation()"
                    >cancel</mat-icon
                  >
                </mat-chip>
              </mat-chip-listbox>
            </mat-select-trigger>
            <mat-option>
              <ngx-mat-select-search
                [placeholderLabel]="'ACCOUNT_MANAGERS.PLACEHOLDER' | translate"
                [noEntriesFoundLabel]="'GENERALS.NO-ITEMS-FOUND' | translate"
                [formControl]="adminsMultiFilterCtrl"
              >
              </ngx-mat-select-search>
            </mat-option>
            <mat-option
              *ngFor="let option of filteredAdminOptions | async"
              [value]="option.id"
            >
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <app-form-errors
          [control]="form.get('account_manager_ids')"
          class="w-100 p-0"
        >
        </app-form-errors>

        <div class="account-managers-empty" *ngIf="adminOptions.length === 0">
          {{ "ACCOUNT_MANAGERS.NO_ADMINS" | translate }}
        </div>
      </form>
    </div>

    <div class="dialog-footer">
      <button
        class="btn gray-bg modal-button m-r-20"
        type="button"
        mat-dialog-close
      >
        {{ "GENERALS.CANCEL" | translate }}
      </button>
      <button
        class="btn orange-bg modal-button"
        type="button"
        (click)="save()"
        [disabled]="adminOptions.length === 0 || form.invalid"
      >
        {{ "GENERALS.SAVE" | translate }}
      </button>
    </div>
  </ng-container>
</div>
